import { createSelector } from "reselect";
import { LicensePlans, LicensePlansLikeInAccountControls, LicenseTypes } from "../const";
import { LicenseState } from "../getLicenseModule";

export const isLicenseLoadedSelector = (state: LicenseState) => !!state.common.license;
export const getLicenseFlags = (state: LicenseState) => state.common?.license?.LicenseFlags;
export const getExpirationDate = (state: LicenseState) => state.common?.license?.ExpirationDate;

export const isHostingTrialLicenseSelector = (state: LicenseState) =>
    state.common.license?.LicenseType === LicenseTypes.HostingTrial;

export const isTrialLicense = (state: LicenseState) => {
    const type = state.common.license?.LicenseType;

    return type === LicenseTypes.HostingTrial || type === LicenseTypes.Trial || type === LicenseTypes.TrialExtendable;
};
/*
 * using only in Amplitude, UserFlow, Intercom, isEnterprisePlan, getLicensePlanLikeAccountControl, getCanUpgradePlan
 */
export const getLicense = (state: LicenseState) => state.common?.license;
/*
 * using only in Intercom
 */
export const getIsEnterprise = createSelector(
    getLicense,
    license =>
        license.LicensePlan === LicensePlans.MixedEnterprise ||
        license.LicensePlan === LicensePlans.NonPSEnterprise ||
        license.LicensePlan === LicensePlans.PSEnterprise ||
        license.LicensePlan === LicensePlans.PMEnterprise ||
        license.LicensePlan === LicensePlans.RMEnterprise
);

/*
 *  Get license plane like in Account control
 */
export const getLicensePlanLikeAccountControl = createSelector(getLicense, license => {
    const licensePlan = license?.LicensePlan;

    switch (licensePlan) {
        case LicensePlans.MixedPro:
            return LicensePlansLikeInAccountControls.LegacyTeam;
        case LicensePlans.MixedEnterprise:
            return LicensePlansLikeInAccountControls.LegacyEnterprise;
        case LicensePlans.NonPSPro:
            return ep.settings.isBirdviewBrand
                ? LicensePlansLikeInAccountControls.PSALite
                : LicensePlansLikeInAccountControls.Team;
        case LicensePlans.NonPSEnterprise:
            return LicensePlansLikeInAccountControls.Enterprise;
        case LicensePlans.PSPro:
            return LicensePlansLikeInAccountControls.PSATeam;
        case LicensePlans.PSEnterprise:
            return LicensePlansLikeInAccountControls.PSAEnterprise;
        case LicensePlans.PMLite:
            return LicensePlansLikeInAccountControls.PMLite;
        case LicensePlans.PMTeam:
            return LicensePlansLikeInAccountControls.PMTeam;
        case LicensePlans.PMEnterprise:
            return LicensePlansLikeInAccountControls.PMEnterprise;
        case LicensePlans.RMTeam:
            return LicensePlansLikeInAccountControls.RMTeam;
        case LicensePlans.RMEnterprise:
            return LicensePlansLikeInAccountControls.RMEnterprise;
        default:
            return licensePlan;
    }
});
